import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { useResponsiveProp, flattenChildren, responsiveCssProperties, } from '../../utils';
import { Box } from '../Box';
import { ButtonGroupContext } from './ButtonGroupContext';
import './ButtonGroup.css';
export const ButtonGroup = forwardRef(function ButtonGroup(props, ref) {
    const { children, variant = { extraSmall: 'vertical' }, className, inverse, size, gap, ...rest } = props;
    const responsiveVariant = useResponsiveProp(variant, 'horizontal');
    const responsiveInverse = useResponsiveProp(inverse, false);
    const responsiveSize = useResponsiveProp(size);
    const renderedChildren = responsiveInverse
        ? flattenChildren(children).reverse()
        : children;
    return (React.createElement(ButtonGroupContext.Provider, { value: { size } },
        React.createElement(Box.Restricted, { ...rest, className: clsx('mollie-ui-button-group', {
                ...responsiveCssProperties('--mollie-ui-button-group-gap', gap),
                [`mollie-ui-button-group--${responsiveVariant}`]: responsiveVariant,
                [`mollie-ui-button-group--${responsiveSize}`]: responsiveSize,
            }, className), ref: ref }, renderedChildren)));
});
export { useButtonGroupContext } from './ButtonGroupContext';
//# sourceMappingURL=ButtonGroup.js.map